import React, { Suspense, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import BrandHeaderAtom from "../components/atoms/brand-header/brand-header";
import { clearAuth } from "../store/slices/authSlice";

// Loading fallback
const LayoutLoading = () => <div className="layout-loading">Loading authentication content...</div>;

const AuthLayout = () => {
    const { isAuthenticated, redirectTo } = useSelector((state) => state.auth) || {};
    const dispatch = useDispatch();

    // Ensure auth is cleared when visiting login pages
    useEffect(() => {
        // Only clear if not already authenticated
        if (!isAuthenticated) {
            dispatch(clearAuth());
        }
    }, [isAuthenticated, dispatch]);

    // If already authenticated, use post-login redirect or default
    if (isAuthenticated) {
        return <Navigate to={redirectTo || "/projects"} replace />;
    }

    return (
        <div className="auth-container">
            <BrandHeaderAtom />
            <div className="auth-content">
                <Suspense fallback={<LayoutLoading />}>
                    <Outlet />
                </Suspense>
            </div>
        </div>
    );
};

export default AuthLayout;
